/**
 * @module
 * @author
 * @version 1.0
 * @description [收拢url相关方法]
 */

import M_PROTOCOL from './../protocol/index.js' // 协议组件
import M_ENV from './../env/index.js' // 协议组件
 
var Url = {
 
    /**
      * @function getUrlInfo
      * @param {string} url - 跳转url[必选]
      * @author
      * @description [解析传入的url，并返回对应的domain、u(相对路径)、qs参数]
      * @instance
      * @return {object}
      * @example
      * M_Url.getUrlInfo('//a.com/b/S123.html?a=123&b=456'); //return {dm: "a.com", u: "/n/S123.html", qs: "?a=123&b=456"};
      */
    // 解析url， 得出domain 、u 、qs
    getUrlInfo: function (url = '') {
        url = M_PROTOCOL.addUrlProtocol(url) // 为url添加协议
 
        var ret = {
                'dm': '',
                'u': '',
                'qs': ''
            },
            arr
 
        if (!url) {
            return ret
        }
 
        // 正则匹配对url没有/的情况解析不了， 暂时通过添加/特殊处理， 满足正则匹配解析规则
        var need_special_handle = 0
        if (url.indexOf('html') <= -1) {
            need_special_handle = 1
        } else {
            arr = url.split('html')
            if (arr[0].indexOf('?') > -1) {
                need_special_handle = 1
            }
        }
 
        if (need_special_handle) {
            arr = url.split('.com')
            url = arr[0] + '.com/'
 
            var length = arr.length
            for (var i = 1; i <= length - 1; i++) {
                url += arr[i]
            }
        }
 
        // 解析url，得出domain 、u 、qs
        var pos = url.indexOf('://')
        if (pos > -1) {
            var re = /(\w+):\/\/([^:|/]+)(:\d*)?(.*\/)([^#|?|\n]+)?(#.*)?(\?.*)?/i
            arr = url.match(re)
 
            if (arr) {
                ret.dm = arr[2]
                ret.u = arr[4] + (arr[5] ? arr[5] : '')
                ret.qs = arr[7] ? arr[7] : ''
            }
            // 链接没有/的特殊处理
            if (need_special_handle) {
                ret.u = '/'
            }
        }
 
        return ret
    },
 
    /**
      * @function getParameter
      * @param {string} name - 参数名[必选]
      * @param {string} url - 解析参数的url [必选]
      * @author
      * @description [从传入url的qs参数中获取指定的参数]
      * @instance
      * @return {string}
      * @example
      * M_Url.getParameter('a', '//a.com/S123.html?a=123&b=456'); //return '123';
      */
    getParameter: function (name = '', url = '') {
        let ret = ''
        if (name && url) {
            let params = this.parse(url)
 
            ret = params[name] || ret
        }
        return ret
    },
 
    /**
      * @function getRefUrl
      * @author
      * @description 获取reffer
      * @instance
      * @return {string}
      * @example
      * M_Url.getRefUrl(); //return 'https://a.com';  //从a页面->b页面，此时调用该方法，则返回a页面的url
      */
    getRefUrl: function () {
        if (M_ENV.isWeexNativeInApp) {
            return weex.config.RefUrl ? weex.config.RefUrl : ''
        } else {
            return document && document.referrer ? document.referrer : ''
        }
    },
 
    /**
      * @function getCrtUrl
      * @author
      * @description 获取当前页面url
      * @instance
      * @return {string}
      * @example
      * M_Url.getCrtUrl(); //return 'https://a.com';  
      */
    getCrtUrl: function () {
        if (M_ENV.isWeexNativeInApp) {
            return weex.config.CrtUrl ? weex.config.CrtUrl : ''
        } else {
            return location && location.href ? location.href : ''
        }
    },
 
    /**
      * @function getUrl
      * @author
      * @description [获取当前页面url、referr]
      * @instance
      * @return {Object}
      * @example
      * M_Url.getUrl(); //return {crtUrl: 'https://a.com/b/c.html', refUrl: 'https://a.com'}; 
      */
    getUrl: function () {
        let _this = this,
            ret = {
                crtUrl: _this.getCrtUrl(), // 当前页面url
                refUrl: _this.getRefUrl() // reffer url
            }
             
        return ret
    },
 
    /**
      * @function joinParams
      * @param {string} url - 需要拼接的url[必选]
      * @param {object} params - 需要添加至url的参数对象 [可选]
      * @author
      * @description  [拼接请求参数]
      * @instance
      * @returns {string} url
      * @example
      * Url.joinParams('//a.com/S123.html', {a: 132, b: 456}); //return '//a.com/S123.html?a=123&b=456';
      */
    joinParams: function (url = '', params = {}) {
        let href = ''
        // 判断url中是否已存在?，若不存在，则在后面补充?
        if (url.indexOf('?') < 0) {
            href = href.concat(url, '?')
        } else {
            href = href.concat(url, '&')
        }
 
        // 遍历入参，若key为空或者undefined则跳过该参数
        for (var key in params) {
            if (key == 'undefined' || !key) {
                continue
            } else {
                // 拼接参数
                href = href.concat(key, '=', encodeURIComponent(params[key]), '&')
            }
        }
 
        // 将多余的字符（?或者&）移除
        href = href.substr(0, href.length - 1)
        return href
    },
 
    /**
      * @function parse
      * @param {string} url - 需要解析的url[必选]
      * @author
      * @description  [将url中的参数解析为对象]
      * @instance
      * @returns {object} {a: '123', b: '456'}
      * @example
      * Url.parse('//a.com/S123.html?a=123&b=456'); //return {a: '123', b: '456'};
      */
    parse: function (url = '') {
        if (!url) {
            return {}
        }
 
        var re = /[?&]([^?&=]+)=([^&]+)/g,
            matcher = re.exec(url), // 匹配&=间的key，value
            items = {}
 
        // 若不为null，则进行赋值
        while (null !== matcher) {
            items[matcher[1]] = decodeURIComponent(matcher[2])
            matcher = re.exec(url)
        }
 
        return items
    },
 
    /**
      * @function buildUri
      * @param {obj} params - [必选]
      * @param {obj} params.route - 路由[必选]
      * @param {obj} params.controller - 控制器[必选]
      * @param {obj} params.action - 方法[必选]
      * @author vincewu
      * @description  [构造uri参数]
      * @instance
      * @returns {string} /route0031/dataCollect/uploadComTrailEnc.json
      * @example M_URL.buildUri({route:'route0031', controller:"dataCollect", action:"uploadComTrailEnc"})
      * 
      */
    buildUri: function (params) {
        if (!params['route'] || !params['controller'] || !params['action']) {
            return ''
        }
 
        return '/' + params['route'] + '/' + params['controller'] + '/' + params['action'] + '.json'
    },
 
    /**
      * @function completeUrl
      * @param {string} url - [必选]
      * @param {string} domain - 路由[必选]
      * @author vincewu
      * @description  [补全url]
      * @instance
      * @returns {string} 
      * @example M_URL.completeUrl()
      * 
      */
    completeUrl (url, domain) {
        let new_url = url ? (/^(http[s]?:)?\/\//.test(url) ? url : '//' + domain + url) : ''
 
        return M_PROTOCOL.addUrlProtocol(new_url)
    },

    /**
     * @function getSecondaryDomain
     * @author melody
     * @description [获取链接的二级域名，默认为 .fenqile.com]
     * @param {string} url[选填] 默认当前url
     * @return {string}
     * @example
     * M_Url.getSecondaryDomain(); //return '.fenqile.com'
     */
    getSecondaryDomain: function (url) {
        const default_domain = 'm.fenqile.com' // 默认domain
        const default_secondary_domain = '.fenqile.com' // 默认二级domain
        const secondary_domain_reg = /\.[a-zA-Z\d-]+\.[a-zA-Z\d-]+$/ // 二级域名匹配正则

        url = url || this.getCrtUrl()

        let url_info = this.getUrlInfo(url)

        let domain = url_info.dm || default_domain

        let reg_exec_result = secondary_domain_reg.exec(domain)

        if (reg_exec_result && reg_exec_result.length) {
            return reg_exec_result[0]
        }
        return default_secondary_domain
    }
 
}
 
export default Url